import { render } from "./BlogArticle.vue?vue&type=template&id=a2da1f54&scoped=true"
import script from "./BlogArticle.vue?vue&type=script&lang=js"
export * from "./BlogArticle.vue?vue&type=script&lang=js"

import "./BlogArticle.vue?vue&type=style&index=0&id=a2da1f54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2da1f54"]])

export default __exports__